import {
  DatePickerInputField,
  InputField,
  SelectField,
  TextareaField,
} from '../../../../components/FormikFields';
import MultipleFileUpload from '../../../../components/FormikFields/MultipleFileUpload/MultipleFileUpload';
import { SELECT_AN_OPTION_LABEL } from '../../../../constants/common';
import {
  FAILURE_TYPES,
  TIME_OF_FAILURE_OPTIONS,
  getAvailableTimeOptions,
} from '../../config/constants';
import styles from './ResolveFailure.styles.scss';

export const resolveFailureFormConfig = ({
  t,
  lang,
  setFieldValue,
  setTouched,
  values,
  readOnly,
}) => [
  {
    title: t('failure_notification.technical_failure_details'),
    fields: [
      {
        name: 'referenceNumber',
        label: t('failure_notification.reference_number'),
        component: InputField,
        componentProps: {
          disabled: true,
        },
      },
      {
        name: 'solutionProviderName',
        label: t('failure_notification.solution_provider_name'),
        component: InputField,
        componentProps: {
          disabled: true,
        },
      },
      {
        name: 'faliureType',
        label: t('failure_notification.failure_type'),
        component: SelectField,
        componentProps: {
          options: FAILURE_TYPES({ lang }),
          value: values.failureType,
          disabled: true,
        },
      },
      {
        name: 'technicalFailureDate',
        label: t('failure_notification.technical_failure_date'),
        component: DatePickerInputField,
        componentProps: {
          className: 'w-100',
          disabled: true,
          displayFormat: 'dd M yy',
        },
      },
      {
        name: 'technicalFailureTime',
        label: t('failure_notification.time_of_failure'),
        component: SelectField,
        componentProps: {
          options: TIME_OF_FAILURE_OPTIONS({ t }),
          disabled: true,
        },
      },
      {
        name: 'expectedResolutionDate',
        label: t('failure_notification.expected_resolution_date'),
        component: DatePickerInputField,
        componentProps: {
          className: 'w-100',
          disabled: true,
          displayFormat: 'dd M yy',
        },
      },
      {
        name: 'technicalFailureDescription',
        label: t('failure_notification.technical_failure_description'),
        component: InputField,
        componentProps: {
          disabled: true,
        },
      },
      {
        name: 'documents',
        label: t('failure_notification.supporting_documents'),
        component: MultipleFileUpload,
        componentProps: {
          acceptedFileTypes: '.jpg, .jpeg, .pdf, .png, .xls, .xlsx, .xlsm',
          maxFileSizeInMB: 5,
          maximumFiles: 3,
          setFieldValue,
          setTouched,
          disabled: true,
          readOnly: true,
        },
        hide: !values.documents || values.documents.length === 0,
      },
    ],
  },
  {
    title: t('failure_notification.resolution_details'),
    fields: [
      {
        name: 'resolutionDate',
        label: t('failure_notification.resolution_date'),
        tooltip: t('failure_notification.tooltips.resolutionDate'),
        component: DatePickerInputField,
        componentProps: {
          className: 'w-100',
          placeholder:
            !readOnly && t('failure_notification.resolution_date_placeholder'),
          minDate: new Date(values.technicalFailureDate),
          maxDate: new Date(),
          disabled: readOnly,
          dateFormat: 'YYYY-MM-DD',
          displayFormat: 'dd M yy',
        },
        required: !readOnly,
      },
      {
        name: 'resolutionTime',
        label: t('failure_notification.resolution_time'),
        tooltip: t('failure_notification.tooltips.resolutionTime'),
        component: SelectField,
        componentProps: {
          className: styles.clockSelect,
          options: [
            {
              value: SELECT_AN_OPTION_LABEL,
              label: t('failure_notification.time_of_resolution_placeholder'),
            },
            ...getAvailableTimeOptions({
              t,
              selectedDate: values.resolutionDate,
            }),
          ],
          disabled: readOnly,
        },
        required: !readOnly,
      },
      {
        name: 'supportingDocuments',
        label: t('failure_notification.upload_supporting_documents'),
        tooltip: t(
          'failure_notification.tooltips.resolutionSupportingDocuments',
        ),
        component: MultipleFileUpload,
        componentProps: {
          acceptedFileTypes: '.jpg, .jpeg, .pdf, .png, .xls, .xlsx, .xlsm',
          fileTypeErrorMessage: t(
            'failure_notification.invalid_file_type_message',
          ),
          placeholder:
            !readOnly &&
            t('failure_notification.supporting_documents_placeholder'),
          maxFileSizeInMB: 5,
          maximumFiles: 3,
          values,
          setFieldValue,
          setTouched,
          readOnly: readOnly,
          disabled: readOnly,
        },
        hide: readOnly && values.supportingDocuments.length === 0,
      },
      {
        name: 'resolutionSupportingDocuments',
        label: t('failure_notification.supporting_documents'),
        component: MultipleFileUpload,
        componentProps: {
          acceptedFileTypes: '.jpg, .jpeg, .pdf, .png, .xls, .xlsx, .xlsm',
          maxFileSizeInMB: 5,
          maximumFiles: 3,
          values,
          setFieldValue,
          setTouched,
          readOnly: readOnly,
          disabled: readOnly,
        },
        hide:
          !readOnly ||
          (readOnly && values.resolutionSupportingDocuments.length === 0),
      },
      {
        name: 'additionalDetails',
        label: t('failure_notification.additional_details'),
        tooltip: t('failure_notification.tooltips.additionalDetails'),
        component: TextareaField,
        componentProps: {
          placeholder:
            !readOnly &&
            t('failure_notification.additional_details_placeholder'),
          disabled: readOnly,
        },
        required: false,
        hide: readOnly && values.additionalDetails.length === 0,
      },
    ],
  },
];
